var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mescroll-touch"},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/images/zhibotop.png")}}),_c('div',{staticClass:"wait"},[_vm._v("敬请期待！")]),_c('floatback')],1)}
var staticRenderFns = []

export { render, staticRenderFns }